import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { IoFilter } from "react-icons/io5";
import { ResponsiveFunnel } from '@nivo/funnel';


const CustomLabels = ({ parts, width }) => (
    <>
      {parts.map(part => (
        <text
            key={part.id}
            x={width}  // right edge of the chart area
            y={part.y}  // vertical center of segment
            textAnchor="end"  // align text to the right
            dominantBaseline="middle"
            style={{
                fill: '#333',
                fontSize: 12,
                fontWeight: 'bold',
                pointerEvents: 'none',
            }}
        >
            {part.data.label}
        </text>
      ))}
    </>
);

const ReportsConversions = ( { user, viewing, contacts, loans, opps } ) => {
    let params = useParams();
    const [ starterObjects, setStarterObjects ] = useState( [ 'Contacts', 'Lead Opportunities', 'Loans' ] );
    const [ starterObj, setStarterObj ] = useState( 'Lead Opportunities' );
    const [ dateObjects, setDateObjects ] = useState( {
        'Contacts': [],
        'Lead Opportunities': [
            { db: 'oppDate', label: 'Opp Date' }
        ],
        'Loans': []
    } );
    const [ dateObj, setDateObj ] = useState( 'oppDate' );
    const [ datePeriod, setDatePeriod ] = useState( 'This Year' );
    const [ startDate, setStartDate ] = useState( '' );
    const [ endDate, setEndDate ] = useState( '' );
    const [ segment, setSegment ] = useState( [] );
    const [ chartData, setChartData ] = useState( [] );
    
    const datePeriods = [ 'This Month', 'Last Month', 'This Quarter', 'Last Quarter', 'This Year', 'Last Year', 'Past Month', 'Past 3 Months', 'Past 6 Months', 'Past 9 Months', 'Past 12 Months', 'Custom' ];
    
    
    useEffect(() => {
        document.title = 'Third Floor - Conversion Report';
    }, [] );

    useEffect( () => {
        let d = new Date();
        let currMonth = d.getMonth() + 1;

        switch ( datePeriod ) {
            case 'This Month':
                setStartDate( `${d.getFullYear()}-${currMonth.toString().padStart( 2, '0' )}-01` );
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                
            case 'Last Month':
                d.setDate( d.getDate() - d.getDate() );
                currMonth = d.getMonth() + 1;
                setStartDate( `${d.getFullYear()}-${currMonth.toString().padStart( 2, '0' )}-01` );
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                
            case 'This Quarter':
                break;
                
            case 'Last Quarter':
                break;
                
            case 'This Year':
                setStartDate( `${d.getFullYear()}-01-01` );
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                
            case 'Last Year':
                setStartDate( `${d.getFullYear()-1}-01-01` );
                setEndDate( `${d.getFullYear()-1}-12-31` );
                break;
                
            case 'Past Month':
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                d.setMonth( d.getMonth() - 1 );
                d.setDate( d.getDate() + 1 );
                setStartDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                    
            case 'Past 3 Months':
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                d.setMonth( d.getMonth() - 3 );
                d.setDate( d.getDate() + 1 );
                setStartDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                
            case 'Past 6 Months':
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                d.setMonth( d.getMonth() - 6 );
                d.setDate( d.getDate() + 1 );
                setStartDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                
            case 'Past 9 Months':
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                d.setMonth( d.getMonth() - 9 );
                d.setDate( d.getDate() + 1 );
                setStartDate( d.toISOString().replace( /T.*/, '' ) );
                break;
                
            case 'Past 12 Months':
                setEndDate( d.toISOString().replace( /T.*/, '' ) );
                d.setMonth( d.getMonth() - 12 );
                d.setDate( d.getDate() + 1 );
                setStartDate( d.toISOString().replace( /T.*/, '' ) );
                break;
            
            case 'Custom':
                setStartDate( '' );
                setEndDate( '' );
                break;

            default:
        }
    }, [ datePeriod ] );

    useEffect( () => {
        const list = [];
        if ( startDate && endDate ) {
            const sd = new Date( startDate );
            const ed = new Date( endDate );

            switch ( starterObj ) {
                case 'Lead Opportunities':
                    Object.keys( opps ).forEach( loid => {
                        const o = opps[loid];

                        if ( !o || !viewing.includes( o.aid ) ) {
                            return;
                        }

                        const od = new Date( o.oppDate );
                        if ( od.getTime() >= sd.getTime() && od.getTime() <= ed.getTime() ) {
                            const obj = {
                                opp: o,
                                oppDate: o.oppDate
                            };

                            if ( o.relationships && o.relationships.length ) {
                                const lor = o.relationships[0];
                                const c = contacts[lor.cid];
                                const l = loans[lor.lid];

                                if ( c ) {
                                    obj.contact = c;
                                }
                                if ( l ) {
                                    obj.loan = l;
                                    obj.prospectDate = l.prospectDate;
                                    obj.appStartedDate = l.appStartedDate;
                                    obj.appCompletedDate = l.appCompletedDate;
                                    obj.appDocsUploadedDate = l.appDocsUploadedDate;
                                    obj.pqDate = l.pqDate;
                                    obj.paDate = l.paDate;
                                    obj.contractDate = l.contractDate;
                                    obj.contractReceivedDate = l.contractReceivedDate;
                                    obj.intentProceedDate = l.intentProceedDate;
                                    obj.rateLockDate = l.rateLockDate;
                                    obj.respaTriggeredDate = l.respaTriggeredDate;
                                    obj.inProcessingDate = l.inProcessingDate;
                                    obj.inUWDate = l.inUWDate;
                                    obj.conditionalApprovalDate = l.conditionalApprovalDate;
                                    obj.cdOrderedDate = l.cdOrderedDate;
                                    obj.cdSignedDate = l.cdSignedDate;
                                    obj.conditionsSubmittedDate = l.conditionsSubmittedDate;
                                    obj.finalApprovalDate = l.finalApprovalDate;
                                    obj.inDocsDate = l.inDocsDate;
                                    obj.docsOutDate = l.docsOutDate;
                                    obj.docsBackDate = l.docsBackDate;
                                    obj.ctcDate = l.ctcDate;
                                    obj.fundedDate = l.fundedDate;
                                    obj.cancelledDate = l.cancelledDate;
                                    obj.creditRepairDate = l.creditRepairDate;
                                }
                            }
                            list.push( obj );
                        }
                    } );
                    break;

                case 'Loans':
                    break;

                default:
            }
            setSegment( list );
        }
    }, [ startDate, endDate, opps, contacts, loans, viewing, starterObj ] );

    useEffect( () => {
        console.log( 'rid: ' + params.rid );
    }, [ params.rid ] );

    useEffect( () => {
        console.log( 'segment: ', segment );
        const chart = [
            { id: 'oppDate', label: 'Leads', color: '#90caf9', value: segment.filter( f => f.oppDate ).length },
            { id: 'appCompletedDate', label: 'Apps', color: '#42a5f5', value: segment.filter( f => f.appCompletedDate || f.appDocsUploadedDate ).length },
            { id: 'paDate', label: 'Pre-Approvals', color: '#1e88e5', value: segment.filter( f => f.paDate || f.pqDate ).length },
            { id: 'contractDate', label: 'Contracts', color: '#81c784', value: segment.filter( f => f.contractDate || f.contractReceivedDate || f.respaTriggeredDate || f.inProcessingDate ).length },
            { id: 'fundedDate', label: 'Funded', color: '#66bb6a', value: segment.filter( f => f.fundedDate ).length },
        ];
        setChartData( chart );
    }, [ segment ] );

    return (
        <Col className='ps-0' style={ { height: '100%' } }>
            <Row className='tf-section-container ms-2'>
                <Col>
                    <Row className='pb-2 border-bottom'>
                        <Col xs='auto' className='pe-2'>
                            <IoFilter size={22} />
                        </Col>
                        <Col className='fw-bold fs-6'>Conversion Filters</Col>
                    </Row>
                    <Row className='p-2 tf-report-filter-item position-relative align-items-center justify-content-start'>
                        <Col xs='auto' className='p-0 ps-4'>
                            <Form.Group as={Row} controlId='starter'>
                                <Col xs='auto'>
                                    <Form.Select size='sm' value={starterObj} onChange={ ( e ) => setStarterObj( e.target.value ) } aria-label=''>
                                        {
                                            starterObjects.map( ( obj, idx ) => <option key={`${obj}-${idx}`} value={obj}>{obj}</option>)
                                        }
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs='auto' className='p-0 ps-2'>
                            <Form.Group as={Row} controlId='starterDate'>
                                <Col xs='auto'>
                                    <Form.Select size='sm' value={dateObj} onChange={ ( e ) => setDateObj( e.target.value ) } aria-label=''>
                                        {
                                            dateObjects[starterObj].map( ( obj, idx ) => <option key={`${obj.db}-${idx}`} value={obj.db}>{obj.label}</option> )
                                        }
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs='auto' className='p-0 ps-2'>
                            <Form.Group as={Row} controlId='starterPeriod'>
                                <Col xs='auto'>
                                    <Form.Select size='sm' value={datePeriod} onChange={ ( e ) => setDatePeriod( e.target.value ) } aria-label=''>
                                        {
                                            datePeriods.map( ( obj, idx ) => <option key={`${obj}-${idx}`} value={obj}>{obj}</option> )
                                        }
                                    </Form.Select>
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs='auto' className='p-0 ps-2'>
                            <Form.Group as={Row} controlId='startDate'>
                                <Col xs='auto'>
                                    <Form.Control type='date' value={startDate} onChange={ ( e ) => setStartDate( e.target.value ) } style={ { fontSize: '.875rem' } } />
                                </Col>
                            </Form.Group>
                        </Col>
                        <Col xs='auto' className='p-0 ps-2'>
                            -
                        </Col>
                        <Col xs='auto' className='p-0 ps-2'>
                            <Form.Group as={Row} controlId='endDate'>
                                <Col xs='auto'>
                                    <Form.Control type='date' value={endDate} onChange={ ( e ) => setEndDate( e.target.value ) } style={ { fontSize: '.875rem' } } />
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className='tf-section-container ms-2'>
                <Col xs='auto' style={{
                    background: '#FFF',
                    borderRadius: '10px', // Rounds the corners
                    boxShadow: '0 4px 5px rgba(0, 0, 0, 0.4)', // Optional shadow for aesthetics
                    height: '300px',
                    width: '500px',
                    color: '#FFF'
                }}>
                    <ResponsiveFunnel
                        data={chartData}
                        layers={['separators', 'parts', 'labels', CustomLabels]}
                        margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                        valueFormat={value => `${value}`}
                        // colors={{ scheme: 'nivo' }}
                        colors={{ datum: 'color' }}
                        borderWidth={5}
                        labelColor={{ from: 'color', modifiers: [['darker', 2]] }}
                        beforeSeparatorLength={50}
                        afterSeparatorLength={50}
                        separatorOffset={20}
                        currentPartSizeExtension={2}
                        currentBorderWidth={5}
                        motionConfig="wobbly"
                    />
                </Col>
            </Row>
        </Col>
    )
}

const mapProps = ( state ) =>( {
    user: state.user,
    viewing: state.user.viewing,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    opps: state.leadopps.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( ReportsConversions );